import { useEffect, useState } from 'react';

export function useValidatedImages(pictures: string[]): string[] {
  const [validatedImages, setValidatedImages] = useState<string[]>([]);

  useEffect(() => {
    const validateImages = async () => {
      // Using only first three pics in preview
      const toValidate = pictures.slice(0, 3);
      const validatedPromises = toValidate.map(
        (pic) =>
          new Promise<string>((resolve) => {
            const img = new Image();
            img.src = pic;
            img.onload = () => resolve(pic);
            img.onerror = () => resolve('/broken-image.svg');
          })
      );
      const results = await Promise.all(validatedPromises);
      setValidatedImages(results);
    };

    validateImages();
  }, [pictures]);

  return validatedImages;
}
